import { render } from "./ReliefShopList.vue?vue&type=template&id=07268f8e&scoped=true"
import script from "./ReliefShopList.vue?vue&type=script&lang=js"
export * from "./ReliefShopList.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css"
import "./ReliefShopList.vue?vue&type=style&index=1&id=07268f8e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07268f8e"]])

export default __exports__